// Components
import { RootState } from '../index';

const getScenarioUsageData = (state: RootState) => state.scenarioUsageDataSlice.scenario_usage;

export { getScenarioUsageData };
